<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"background-image: url(\"https:\/\/api.geramyan.com\/storage\/bargiri\/6VizBzuecNXf0LGde6iKJI8QU3keZVtHfLePj05D.jpg1745604394.jpg\");\nheight:100vh;"' class="container-fluid p-0 mb-5 pb-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row pb-5 p-0 m-0" >
                <template #default>   <m-complete-profile-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-complete-profile-message-1><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-12 my-4" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>آگهی های من   </template>
                </m-h3><m-products-304 v-bind='{...{"perPage":15,"productCardName":"ProductCard3_1_edit_button","cardCLass":"my-1","cardWrapperCLass":"col-lg-4 archive-parent-item","offerType":"number","offerStatus":true,"productBrandProp":true,"productSearchProp":true,"productQuantityProp":true,"productFeatureProp":true,"productFeaturePanelOpenCloseProp":false,"productCategoryProp":false,"productStoresProp":true,"productSortProp":true,"relatedCurrentCategory":true,"productPriceFilterProp":true,"cardLinkType":"_self","showKeywords":false,"smCardName":"ProductCard3_1_edit_button","dashboardProduct":true,"publishStatusFilter":false,"image":null,"alt":"","cardLink":false},...{}}' :style='""' class="product-archive-304" ></m-products-304></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mCompleteProfileMessage1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Message/CompleteProfileMessage1'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mProducts304 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products304/Products304';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mCompleteProfileMessage1,mH3,mProducts304 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
